exports.api = {
    login: `login`,
    sendOtp: `send-otp`,
    registerSendOtp: `register/send-otp`,
    otpVerify: `verify-otp`,
    register: `register`,
    logout: `logout`,
    notification: `notification/list`,
    unseenNotification: `notification/unseen-count`,
    clearNotification: `notification/clear`,
    seenNotification: `notification/seen/`,
    dashboard: `user/home`,
    userDetail: `provider/detail/`,
    advertisementDetail: `advertisement/details/`,
    addServiceRequest: `service/request-details`,
    sendRequest: `service/send-request`,
    providerList: `provider/List`,
    providerChatList: `service/chat/provider-list`,
    providerDetail: `provider/detail/`,
    bookingList: `service/booking/list`,
    serviceRequest: `service/deal/status/`,
    submitRating: `reviews/add`,
    myJobs: `service/request/myjob`,
    jobDetail: `service/request-details`,
    moreProvider: `schedule/provider/List`,
    cancelServiceRequest: `service/request/cancel/`,
    jobDelete: `service/request-delete/`,
    profile: `user/profile`,
    updateProfile: `user/update/`,
    updateProfileImage: `user/profile-image`,
    deleteAccount: `delete`,
    careNetworkList: `job/list`,
    applyJob: `job/apply`,
    careNetworkDetail: `provider/posted/job/detail/`,
    jobRequest: `user/job/requested`,
    jobRequestCount: `user/job/requested/count`,
    jobRequestSeen: `user/job/requested/seen`,
    appliedJob: `job/applied-list`,
    addPost: `job/post`,
    addPostPayment: `payment/job-post`,
    deletePost: `job/post/`,
    postedJob: `user/posted/job`,
    newsletterSubscribe: `newsletter/subscribe`,
    newsletterUnsubscribe: `newsletter/un-subscribe`,
    addNewsletter: `newsletter/add`,
    planList: `admin/plan`,
    categoryList: `category/list`,
    transactionList: `transaction/history`,
    calendarData: `provider/calenders`,
    sendContactUs: `contactus`,
    contactUsDetail: `contactus`,
    chatImage: `chat/image`,

    expenseDashboard: `expense/dashboard`,
    expenseListing: `expense/list`,
    addBudget: `budget/add`,
    expenseDelete: `expense/delete/`,
    addExpense: `expense/add`,
    editExpense: `expense/update/`,
    detailsExpense: `expense/detail/`,
    categoryListing: `expense/category/list`,
    addCategory: `expense/category/add`,
    cardListing: `expense/card`,
    addCard: `expense/card`,
    budgetList: `budget/list`,
    budgetDelete: `budget/delete/`,
    budgetUpdate: `budget/update/`,

    communityDashboard: `community/dashboard`,
    communitySuggested: `community/list`,
    communityFollow: `community/follow/`,
    communityUnFollow: `community/unfollow/`,
    communityFollowing: `community/my-following`,
    communityList: `community/my-created`,
    communityAdd: `community/add`,
    communityUpdate: `community/update/`,
    communityDelete: `community/delete/`,
    communityDetail: `community/details/`,
    postAdd: `community/post`,
    postUpdate: `community/post/update/`,
    pollAnswer: `community/poll/user/response`,
    postReaction: `post/reaction`,
    communityPostDetail: `community/post/detail/`,
    postComment: `post/comment/add`,
    communityPostDelete: `community/post/delete/`,
    communityCommentDelete: `post/comment/delete/`,
    commentUpdate: `post/comment/update/`,
    commentReaction: `post/comment/reaction`,
    shareProfile: `community/shared/profile`,
    shareCommunityList: `user/community/list`,

    loyaltyCouponList: `coupon/list`,
    leadCouponList: `loyalty/coupon/list`,
    cancelCoupon: `loyalty/coupon/cancel`,
    postCouponApply: `loyalty/post/coupon/apply`,
}